import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { keys } from 'components/IncidentConfig/hooks/useGetIncidentPositionInfo';

interface UpdatePositionAndRoleParams {
  incidentId: string;
  position: {
    id: string;
    name: string;
  };
  permissions: {
    id: string;
  }[];
}

export const useUpdatePositionAndRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdatePositionAndRoleParams) => {
      const response = await axios.post(
        apiConfig.apiGateway.incidentPositionAndRole,
        params
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: keys.byPosition(variables.incidentId, variables.position.id),
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.ERROR || 'Failed to update position and role'
      );
    },
  });
};
